import {Label} from './Label';
import {TwoEndArrow} from './TwoEndArrow';

declare let THREE: any;

export class Dimension extends (THREE.Object3D as { new(): any; }) {

  constructor(color) {
    super();
    this.add(new TwoEndArrow(color));
    this.add(new Label({width: 70, height: 40}, {fontSize: 30}));
    this.visible = false;
  }

  update(firstPoint, secondPoint, formatter: (length: number) => string) {
    const length = firstPoint.distanceTo(secondPoint);
    const lineDirection = secondPoint.clone().sub(firstPoint).normalize();
    const arrow = this.getObjectByName('arrow');
    arrow.rotation.y = -Math.atan2(secondPoint.z - firstPoint.z, secondPoint.x - firstPoint.x);
    arrow.setLength(length);
    const label = this.getObjectByName('label') as Label;
    label.updateText(formatter(length));
    label.position.copy(lineDirection.multiplyScalar(length / 2));
    this.position.copy(firstPoint);
    this.visible = true;
  }

}



// WEBPACK FOOTER //
// ./src/app/custom/Dimension.ts